import instanciaAxios from "../../miscelaneo/instanciaAxios";
import { useContextoSesion } from '../../miscelaneo/ContextoSesion'; // Importa el hook del contexto


const FuncionesGenerales = (usuario = null) => {
    const formatearFechaInput = (fechaISO) => {
        if (!fechaISO) return "";
        return new Date(fechaISO).toISOString().split('T')[0];
    };
    const formatearFechaHoraInput = (fechaISO) => {
    if (!fechaISO) return "";
    const fecha = new Date(fechaISO);
    // Ajuste para la zona horaria local
    const offset = fecha.getTimezoneOffset();
    const fechaLocal = new Date(fecha.getTime() - offset * 60000);
    return fechaLocal.toISOString().slice(0, 16); // Retorna en formato YYYY-MM-DDTHH:mm
    };

    const obtenerFechaHoraActual = () => {
    const ahora = new Date();
    const offset = ahora.getTimezoneOffset(); // Diferencia en minutos
    const fechaLocal = new Date(ahora.getTime() - offset * 60000);
    return fechaLocal.toISOString().slice(0, 16);
    };

    const obtenerFechaActual = () => {
    const ahora = new Date();
    const offset = ahora.getTimezoneOffset();
    const fechaLocal = new Date(ahora.getTime() - offset * 60000);
    return fechaLocal.toISOString().slice(0, 10);
    };
    
const formatoMoneda = (valor, monedaParam) => {
    const moneda = monedaParam ?? usuario?.configuracionSistema?.moneda ?? 'DOP';
    
    return new Intl.NumberFormat('es-DO', {
        style: 'currency',
        currency: moneda,
    }).format(valor);
};

    // Formatear fecha para mostrar (DD/MM/YYYY)
    const formatearFecha = (fechaISO) => {
        if (!fechaISO) return "";
        const fecha = new Date(fechaISO);
        return fecha.toLocaleDateString('es-DO', {
            day: '2-digit',
            month: '2-digit', 
            year: 'numeric'
        });
    };

    return { formatearFechaInput, obtenerFechaHoraActual, formatearFechaHoraInput, formatoMoneda, obtenerFechaActual, formatearFecha };
};

export default FuncionesGenerales;


